<template>
  <div class="page-hero">
    <div class="page-hero__text-container">
      <h1 class="page-hero__heading">{{data.headlineText}}</h1>
      <rich-text class="page-hero__text" :textData="data.introCopy" />
      <div class="page-hero__button">
        <a
          class="page-hero__button-link"
          :href="data.introButtonLink"
        >{{data.introButtonText}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import RichText from './RichText.vue';

export default {
  props: ['data'],
  components: { RichText },
};
</script>

<style scoped>
.page-hero {
  display: flex;
}

.page-hero__text-container {
  display: flex;
  flex-flow: wrap;
  min-height: 400px;
}

.page-hero__heading {
  width: 100%;
  margin: 0;
  font-family: var(--headline-font);
  font-weight: normal;
  font-size: 72px;
  line-height: 1;
  color: var(--dark-purple);
}

.page-hero__text {
  margin: 18px 0 0 0;
  font-family: var(--body-font);
  line-height: 1.5;
  color: var(--old-burgandy);
}

.page-hero__button {
  font-size: 14px;
  padding: 16px 20px;
  margin-bottom: 36px;
  text-transform: uppercase;
  background-color: var(--twenty-five-lighter);
  border-radius: 3px;
}

.page-hero__button-link {
  color: var(--dark-purple);
  text-decoration: none;
}

@media screen and (min-width: 640px) {
  .page-hero__text-container {
    min-height: 600px;
    max-width: 400px;
    align-content: center;
    margin-left: 72px;
  }
}
</style>
